import React from "react";
import images from "../../assets";
import ActivityTimelineValue from "./activitytimelinevalue";
import { Select } from "antd";

export default function UsageAnalyticsComp() {
  return (
    <div className="w-full flex flex-col gap-6">
      <h2>Usage Analytics</h2>
      <div className="w-full justify-start items-start gap-[19px] flex flex-wrap">
        <div className="w-[586px] p-5 bg-white rounded-xl shadow border border-primary50 flex-col justify-start items-start gap-2.5 inline-flex">
          <div className="self-stretch flex-col justify-center items-end gap-2.5 flex">
            <div className="self-stretch flex-col justify-start items-start gap-[39px] flex">
              <div className="self-stretch flex-col justify-start items-center gap-6 flex">
                <h3 className="text-[#222222] text-base font-semibold font-['Poppins'] leading-normal">
                  Total Time Spent
                </h3>
                <p className="text-secondary text-7xl font-semibold leading-[72px]">
                  6 hrs 40 mins
                </p>
              </div>
              <div className="self-stretch flex-col justify-start items-start gap-2 flex">
                <ActivityTimelineValue
                  title="Average Spent Time"
                  value="25 mins/visit"
                />
                <ActivityTimelineValue
                  title="Last Spent Time"
                  value="17 mins"
                />
                <ActivityTimelineValue
                  title="Last Activity Type"
                  value="Photo Request"
                />
                <ActivityTimelineValue
                  title="Total Number of Visits"
                  value="27"
                />
                <ActivityTimelineValue
                  title="Total Activities"
                  value={
                    <a className="text-secondary font-semibold" href="#">
                      1120
                    </a>
                  }
                />
              </div>
            </div>
            <div className="justify-start items-center gap-2 inline-flex">
              <div className="text-right text-[#222222]/60 text-xs font-normal font-['Poppins'] leading-[18px]">
                Updated today at 11:46 am
              </div>
              <div className="w-5 h-5 relative">
                <img src={images.syneIcon} />
              </div>
            </div>
          </div>
        </div>

        <div className="w-[290px] px-4 py-5 bg-white rounded-2xl shadow border border-primary50 flex-col justify-between items-start gap-6 flex">
          <div className="justify-center items-center gap-3 inline-flex">
            <div className="text-center text-[#222222] text-sm font-normal font-['Poppins'] leading-tight">
              Select Date:
            </div>
            <Select
              showSearch
              style={{
                width: 155,
                height: 48,
              }}
              placeholder="Please Select"
              options={[
                {
                  value: "1",
                  label: "Today",
                },
                {
                  value: "2",
                  label: "Last Weeks",
                },
                {
                  value: "3",
                  label: "Last 2 Months",
                },
                {
                  value: "4",
                  label: "Life Time",
                },
              ]}
            />
          </div>
          <div className="flex-col justify-start items-start gap-2.5 flex">
            <ActivityTimelineValue title="Time Spent" value="2 hr 48 min" />
            <ActivityTimelineValue
              title="Total Activity"
              value={
                <a className="text-secondary font-semibold" href="#">
                  112
                </a>
              }
            />
            <ActivityTimelineValue title="No. of Visit" value="12" />
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col items-center justify-center gap-8 mt-8">
        <h2 className="w-[70%] border p-8 text-center">Time Spend 1</h2>
        <h2 className="w-[70%] border p-8 text-center">Time Spend 2</h2>
      </div>
    </div>
  );
}
